import styled from "styled-components";
import { InputGroup, Table } from "react-bootstrap";

interface IProps {
    fontSize?: number
}

export const TableWrapper = styled(Table) <IProps>`
    margin-bottom: 300px;

    & > thead > tr > th,
    & > tbody > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + "px" : "14px"};
        vertical-align: middle;

        select.form-control {
            font-size: ${p => p.fontSize ? p.fontSize + "px !important" : "14px !important"};
        }

        input.form-control {
            font-size: ${p => p.fontSize ? p.fontSize + "px !important" : "14px !important"};
        }
    }
`;

export const TableWrapperLogistics = styled(Table) <IProps>`
    & > thead > tr > th,
    & > tbody > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + "px" : "14px"};
        vertical-align: middle;

        select.form-control {
            font-size: ${p => p.fontSize ? p.fontSize + "px" : "14px"};
        }

        input.form-control {
            font-size: ${p => p.fontSize ? p.fontSize + "px" : "14px"};
        }
    }

    .form-control-static {
        border: 1px solid #ccc;
        min-height: 26px;
        padding: 3px 6px;
        border-radius: 4px;
        background-color: #ddd;
    }
`;

export const TableHeadWrapper = styled.thead<IProps>`
    & > tr > th {
        padding: 3px !important;
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }
`;

export const SwapTrackerTableHeadWrapper = styled.thead<IProps>`
    & > tr > th {
        padding: 3px !important;
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        text-align: center;
        border-bottom-width: 0px;
    }
`;

export const TableBodyWrapper = styled.tbody<IProps>`
    & > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        padding: 2px !important;
    }

    & > tr > td > div > div > span {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }
`;

export const TableBodyWrapperOptions = styled.tbody<IProps>`
    & > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        padding: 3px !important;
    }

    & > tr > td > div > div > span {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }
`;

export const LogisticsPlansTableBodyWrapper = styled.tbody<IProps>`
    & > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        padding: 2px !important;
        text-align: center;
    }

    & > tr > td > div > div > span {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }
`;

export const SwapTrackerTableBodyWrapper = styled.tbody<IProps>`
    & > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        text-align: center;
    }

    & > tr > td > div > div {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }

    & > tr > td > div > div > span {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
    }
`;

export const PillWrapper = styled.li`
    & > a {
        //padding: 3px 7px !important;
        border: ${p => p.className == null ? "1px solid darkgrey !important" : "1px solid #337ab7"};
    }

    margin-right: 5px;
`

export const LogisticsTableBodyWrapper = styled.tbody<IProps>`
    & > tr > td {
        font-size: ${p => p.fontSize ? p.fontSize + 'px !important' : '12px !important'};
        padding: 7px !important;
        border-top: 0 none !important;
    }
`;

export const TimezoneValueWrapper = styled.div`
    height: 26px;
    padding: 3px 6px;
    line-height: 18px;
    font-size: 12px;
    width: 45%;
    margin-left: 3px;
`;

export const EpletDetailsTableWrapper = styled(Table)`
    & > tbody > tr > td {
        border: 0 none;
    }
`;